

















import { Component, Mixins } from "vue-property-decorator";
import { RectangleDragHandles } from "../../../../../../base/components/dragging";
import { CircleDrawer } from "../../../../../../base/components/drawing/drawers";
import { TexturedShapeObjectDrawerBase } from "./base";

@Component({
  components: {
    CircleDrawer,
    RectangleDragHandles,
  },
})
export default class CircleObjectDrawer extends Mixins(TexturedShapeObjectDrawerBase) {}
